import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    workQty: {
        type: "input",
        label: "Quantity Of Work",
        isRequired: true,
        xs: 8,
        lg: 3,
        sm: 6,
        md: 3,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    unit: {
        type: "input",
        label: "Unit",
        isRequired: true,
        xs: 4,
        lg: 1,
        sm: 2,
        md: 1,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            }
        }
    },
    rate: {
        type: "input",
        label: "Rate In INR (per unit)",
        isRequired: false,
        hide : true,
        xs: 8,
        lg: 3,
        sm: 6,
        md: 3
    }
};

export default FIELDS;